import React from 'react';

export default function AndroidUpdatePrompt({
  androidUpdateInfo,
  nativeAndroidVersion,
  currentAndroidVersion,
  autoUpdateStatus,
  autoUpdateInProgress,
  onInstall,
  onDismiss,
}) {
  if (!androidUpdateInfo) return null;

  return (
    <div className="android-update-card">
      <div className="android-update-content">
        <div>
          <strong>Nieuwe app-update beschikbaar</strong>
          <div className="kleine-tekst">
            Versie {androidUpdateInfo.version || 'nieuw'} staat klaar. Je gebruikt nu {nativeAndroidVersion || currentAndroidVersion}.
          </div>
          {androidUpdateInfo.notes && <div className="kleine-tekst android-update-notes">{androidUpdateInfo.notes}</div>}
          {autoUpdateStatus && <div className="kleine-tekst android-update-notes">{autoUpdateStatus}</div>}
        </div>
        <div className="android-update-actions">
          <button className="krinkels-button" disabled={autoUpdateInProgress} onClick={onInstall}>
            {autoUpdateInProgress ? 'Bezig met downloaden...' : 'Update downloaden en installeren'}
          </button>
          <button className="krinkels-button secondary" onClick={onDismiss}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
